import React, { useCallback, useRef, useState, useEffect } from 'react';
import { useAppSelector } from '../store/hooks';
import { useParams } from 'react-router-dom';
import { ArticleItem } from '../types/typedeclaration';
import LoadmorenewsBox from '../components/LoadmorenewsBox';
// import data from '../assets/json/home.json';
import { useSwipe } from '../store/useSwipe';
import fetchData from 'Utilis/request';
import {Loader} from 'components/Index';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const CategoryPage = () => {

  const { categoryId } = useParams();  
  const settingLocalData = useAppSelector((state: any) => state.staticSettingSlice.data);     
  const darkMode = useAppSelector((state: any) => state.categoryNavigation.darkmode);
  const fontSize = useAppSelector((state: any) => state.categoryNavigation.fontsize);  
  const headerHeight = useAppSelector((state: any) => state.categoryNavigation.headerHeight || 0);
  const fooNavHeight = useAppSelector((state: any) => state.categoryNavigation.fooNavHeight || 0);
  const { onTouchStart, onTouchMove, onTouchEnd } = useSwipe();  
  const newsContainerRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [articles, setArticles] = useState<ArticleItem[]>([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [currentCategory, setCurrentCategory] = useState<string | undefined>();



// console.log(settingLocalData?.menu, " settingLocalData on cat")
  // Reset state when category changes
  useEffect(() => {
    // Always reset state when category changes, regardless of previous state
    setCurrentCategory(categoryId);
    setArticles([]);
    setOffset(0);
    setHasMore(true);
    setLoading(true); // Set loading immediately
    
    // Use a separate variable to track the current category during async operation
    const currentCat = categoryId;
    
    const fetchInitialData = async () => {
      try {
        // const article = await articlesByCategories(currentCat || "", 0);


 const article = await fetchData.getResult(`${API_BASE_URL}getArticleByCat.php?slug=${currentCat}&start=0`);


        const items = article?.articles || [];
        
        // Only update state if we're still on the same category
        if (currentCat === categoryId) {
          setArticles(items);
          setOffset(20);
          setHasMore(article?.status !== false);
        }
      } catch (error) {
        console.error("Error fetching videos:", error);
      } finally {
        if (currentCat === categoryId) {
          setLoading(false);
        }
      }
    };

    fetchInitialData();
  }, [categoryId]);

  const fetchVideos = useCallback(async (increment: number) => {
    if (loading || !hasMore) return;
    setLoading(true);

    try {
      const article = await fetchData.getResult(`${API_BASE_URL}getArticleByCat.php?slug=${categoryId}&start=${increment}`);
      const items = article?.articles || [];

      setArticles(prev => [...prev, ...items]);
      setOffset(increment + 20);
      
      // Update hasMore based on both status and items length
      const noMoreItems = article?.status === false || items?.length === 0;
      setHasMore(!noMoreItems);

    } catch (error) {
      console.error("Error fetching videos:", error);
    } finally {
      setLoading(false);
    }
  }, [categoryId, loading, hasMore]);

  const shouldFetchMore = useCallback(() => {
    if (!newsContainerRef.current) return false;
    const { scrollTop, scrollHeight, clientHeight } = newsContainerRef.current;
    return scrollTop + clientHeight >= scrollHeight - 100;
  }, []);

  const handleScroll = useCallback(async () => {
    if (!shouldFetchMore() || loading || !hasMore) return;
    await fetchVideos(offset);
  }, [shouldFetchMore, fetchVideos, offset, loading, hasMore]);

  const categorytitle = settingLocalData?.menu.find((item: any) => item.id === categoryId)?.title || categoryId;
  

  return (
    <div className={`font-sans min-h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>    
      <main className="cat-page"
        ref={newsContainerRef}
        onScroll={handleScroll}        
         style={{ height: `calc(100vh - ${fooNavHeight+10}px)`, overflowY: 'auto', paddingTop:headerHeight+10 }}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        >
        <div className="news-container">
          <LoadmorenewsBox
            darkMode={darkMode}
            fontSize={fontSize}
            articles={articles}               
            inlineView={true}
            title={categorytitle}
          />
          {loading && <Loader darkMode={darkMode}/>}
          {!hasMore && articles.length > 0 && <div className="text-center py-4">No more Articles to load</div>}
          {!loading && articles.length === 0 && <div className="text-center py-4">No articles found</div>}
        </div>
      </main>
    </div>
  );
};

export default CategoryPage;